import React from "react";
import { Box, Typography } from "@mui/material";
import Image from "next/image";
import { colors } from "src/config/colors";
import Container from "src/components/common/Layout/Container";
import { createUrl } from "src/utils/helpers/url/createUrl";
import paths from "src/router/paths";
import { useRouter } from "next/router";

interface BigArticleProps {
  title: string;
  date: string;
  img: string;
  slug: string;
}

const BigArticle: React.FC<BigArticleProps> = ({ title, date, img, slug }) => {
  const router = useRouter();

  return (
    <Container
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      <Box
        sx={{
          borderRadius: { xs: "8px 8px 0px 0px", md: "8px 0px 0px 8px" },
          overflow: "hidden",
          aspectRatio: "16 / 9",
          width: "100%",
          position: "relative",
        }}
      >
        <Image layout="fill" src={img} alt="картинка статьи" />
      </Box>
      <Box
        sx={{
          backgroundColor: colors.white,
          minWidth: { xs: "100%", md: "384px" },
          width: { xs: "100%", md: "384px" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: { xs: "16px", md: "24px" },
          borderRadius: { xs: "0px 0px 8px 8px", md: "0px 8px 8px 0px" },
        }}
      >
        <Box
          sx={{
            width: "68px",
            height: "32px",
            borderRadius: "16px",
            backgroundColor: colors.blue2,
            padding: "8px 16px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: colors.white,
            mb: 3,
            fontSize: "14px",
          }}
        >
          Новое
        </Box>
        <Box>
          <Typography
            onClick={() =>
              router.push(createUrl([paths.BLOG, paths.ARTICLE, slug]))
            }
            component="h6"
            sx={{
              fontSize: { xs: "16px", tb: "24px" },
              color: colors.black2,
              mb: 2,
              lineHeight: { xs: "20px", tb: "31px" },
              fontWeight: 500,
              cursor: "pointer",
              ":hover": {
                opacity: 0.7,
              },
            }}
          >
            {title}
          </Typography>
          <Typography
            component="span"
            sx={{
              fontSize: { xs: "12px", tb: "16px" },
              color: colors.gray3,
            }}
          >
            {date}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default BigArticle;
